import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import router from "@/router";
import { ElMessage, ElMessageBox } from "element-plus";
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload
  },
  setup: function setup() {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var activityId = route.query.activityId;
    var detailId = route.query.detailId;
    var flags = ref();
    flags.value = detailId; // 提交按钮文字

    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit;
    var baseUrl = process.env.VUE_APP_BASE_URL; // 数据

    var detail = reactive({
      seachName: "",
      content: "",
      leftNum: "",
      optionId: "",
      detailContent: {
        activity: {
          activityType: "",
          activityId: "",
          voteName: '',
          voteCycle: 1,
          description: ''
        },
        number: ""
      },
      option: [{
        number: "",
        picture: ''
      }],
      description: '',
      flagMore: false,
      checkMore: 1
    }); // 详情回显

    var col = ref(false);

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } //获取投票详情


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti2, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getVoteDetail"](activityId);

              case 2:
                _yield$globalProperti2 = _context3.sent;
                data = _yield$globalProperti2.data;
                detail.detailContent = _objectSpread({}, data);
                detail.description = detail.detailContent.activity.description;

                if (detailId) {
                  col.value = true;
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getDetail.apply(this, arguments);
    }

    function voteuserInfo() {
      return _voteuserInfo.apply(this, arguments);
    }

    function _voteuserInfo() {
      _voteuserInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti3, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (detailId) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["voteuserInfo"](activityId);

              case 3:
                _yield$globalProperti3 = _context4.sent;
                data = _yield$globalProperti3.data;
                detail.leftNum = data.leftNum;

                if (data.optionId) {
                  detail.optionId = data.optionId.split(',').slice(0, 1).join('');
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _voteuserInfo.apply(this, arguments);
    }

    var loading = ref(true); //获取选项详情

    function getOptionDetail() {
      return _getOptionDetail.apply(this, arguments);
    }

    function _getOptionDetail() {
      _getOptionDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$globalProperti4, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["lookOptionList"]({
                  optionName: detail.seachName
                }, activityId);

              case 2:
                _yield$globalProperti4 = _context5.sent;
                data = _yield$globalProperti4.data;
                detail.option = data;
                loading.value = false;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _getOptionDetail.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getDetail();
      getOptionDetail();
      voteuserInfo();
    }); //点击投票

    function gorank(optionId) {
      var activityType = Number(detail.detailContent.activity.activityType);

      if (activityType == 1) {
        detail.content = "确定投票给该选手吗?";
      } else if (activityType == 2) {
        detail.content = "确定投票给该作品吗?";
      } else {
        detail.content = "确定投票给该事件吗?";
      }

      ElMessageBox({
        title: "提示",
        message: detail.content,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, code, msg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["clickVote"]({
                  optionId: optionId,
                  activityId: detail.detailContent.activity.activityId
                });

              case 2:
                _yield$globalProperti = _context.sent;
                code = _yield$globalProperti.code;
                msg = _yield$globalProperti.msg;

                if (code == 0) {
                  ElMessage.success("投票成功");
                  changeInfoTotal(detail.detailContent.activity.activityId, "\u6295\u7968\u6D3B\u52A8\uFF1A".concat(detail.detailContent.activity.voteName), 22);
                  voteuserInfo();
                  getOptionDetail();
                  getDetail();
                } else {
                  ElMessage.error(msg);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function () {// console.log("2222");
      });
    } //点击搜索


    function search() {
      return _search.apply(this, arguments);
    } //点击查看投票情况


    function _search() {
      _search = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$globalProperti5, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["lookOptionList"]({
                  optionName: detail.seachName
                }, detail.detailContent.activity.activityId);

              case 2:
                _yield$globalProperti5 = _context6.sent;
                data = _yield$globalProperti5.data;
                detail.option = data;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _search.apply(this, arguments);
    }

    function open() {
      ElMessageBox({
        title: "投票结果",
        message: "\u60A8\u7684\u6295\u7968\u7ED3\u679C\u662F ".concat(detail.detailContent.number),
        showCancelButton: false,
        showConfirmButton: false
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function () {// console.log("2222");
      });
    } //查看排行


    var checkRank = function checkRank(activityId) {
      router.push({
        name: "investigateRank",
        query: {
          activityId: activityId
        }
      });
    }; //查看人员详情


    var seeRank = function seeRank(optionId) {
      var activityType = detail.detailContent.activity.activityType;
      router.push({
        name: "investigateRankDetail",
        query: {
          optionId: optionId,
          activityType: activityType
        }
      });
    }; //查看更多


    var lookMore = function lookMore() {
      detail.checkMore = -detail.checkMore;
    };

    return {
      submitText: submitText,
      gorank: gorank,
      checkRank: checkRank,
      seeRank: seeRank,
      search: search,
      detail: detail,
      col: col,
      open: open,
      baseUrl: baseUrl,
      loading: loading,
      flags: flags,
      lookMore: lookMore
    };
  }
});